import { useState } from 'react';
import { guideFaqs } from '@/mocks/home';

export default function GuideFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <ul className="flex flex-col gap-3">
      {guideFaqs.map((f, i) => {
        const open = openIndex === i;
        return (
          <li key={f.q} className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
            <button
              type="button"
              onClick={() => setOpenIndex(open ? null : i)}
              aria-expanded={open}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
            >
              <span className="text-sm md:text-base font-bold text-foreground-950">{f.q}</span>
              <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className={open ? 'ri-subtract-line text-lg' : 'ri-add-line text-lg'}></i>
              </span>
            </button>
            {open && (
              <div className="px-5 pb-5">
                <p className="text-sm leading-7 text-foreground-600 border-t border-background-200 pt-4">{f.a}</p>
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}